module.exports = __webpack_public_path__ + "static/media/street.dcf6ab41.jpg";